import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import MarkdownWrapper from "../../MarkdownWrapper";

/**
 * Cuerpo de un mensaje con «Leer más», como WhatsApp (doc 0438, revisión del propietario).
 *
 * WHY: un texto de miles de caracteres ocupaba pantallas enteras y obligaba a desplazarse sin fin,
 * en cualquier canal. Se muestran PRIMEROS caracteres y cada «Leer más» descubre un bloque más; el
 * corte cae en un espacio para no partir palabras. El mensaje guardado no cambia: es solo la vista.
 */
const VISIBLE_INICIAL = 700;
const BLOQUE = 2000;
const HOLGURA = 150; // si solo sobra un poco, se enseña entero: un «Leer más» para tres palabras irrita

const useStyles = makeStyles((theme) => ({
  enlace: {
    display: "inline-block",
    marginTop: 4,
    padding: 0,
    border: 0,
    background: "none",
    cursor: "pointer",
    fontSize: "0.85rem",
    fontWeight: 600,
    color: theme.palette.type === "dark" ? "#8ab4f8" : "#027eb5",
  },
}));

const cortar = (texto, limite) => {
  if (texto.length <= limite) return texto;
  const espacio = texto.lastIndexOf(" ", limite);
  return texto.slice(0, espacio > limite * 0.8 ? espacio : limite).trimEnd() + "…";
};

const ExpandableBody = ({ message, text }) => {
  const classes = useStyles();
  const completo = typeof text === "string" ? text : null;
  const [visibles, setVisibles] = useState(VISIBLE_INICIAL);

  useEffect(() => setVisibles(VISIBLE_INICIAL), [message?.id]);

  if (completo === null || completo.length <= VISIBLE_INICIAL + HOLGURA) {
    return <MarkdownWrapper message={message}>{text}</MarkdownWrapper>;
  }

  const queda = completo.length - visibles;
  const todo = queda <= HOLGURA;

  return (
    <>
      <MarkdownWrapper message={message}>{todo ? completo : cortar(completo, visibles)}</MarkdownWrapper>
      <div>
        {todo ? (
          <button type="button" className={classes.enlace} onClick={() => setVisibles(VISIBLE_INICIAL)}>
            Mostrar menos
          </button>
        ) : (
          <button type="button" className={classes.enlace} onClick={() => setVisibles((v) => v + BLOQUE)}>
            Leer más
          </button>
        )}
      </div>
    </>
  );
};

export default ExpandableBody;
